export const chooseSolutionRoute = 'choose-solution';
export const paymentTypeRoute = 'payment-type';
export const yourDetailsRoute = 'your-details';
export const orderSummaryRoute = 'order-summary';
export const orderOutcomeRoute = 'order-outcome';
export const orderPaymentRoute = 'order-payment';
export const orderPaymentStatusRoute = 'order-payment-status';
export const assignDevicesRoute = 'assign-devices';
export const setupComplete = 'setup-complete';
export const processPaymentRoute = 'process-payment';
